var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook_1_",
    "data-name": "facebook (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.945,
    height: 71.945,
    viewBox: "0 0 71.945 71.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6956",
    "data-name": "Group 6956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6955",
    "data-name": "Group 6955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15537",
    "data-name": "Path 15537",
    d: "M212.724,157.813v3.27h-3.27v4.905h3.27V180.7h6.54V165.988h4.349l.556-4.905h-4.905v-2.862c0-1.324.131-2.028,2.175-2.028h2.731v-4.922h-4.382C214.556,151.272,212.724,153.725,212.724,157.813Z",
    transform: "translate(-180.022 -130.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15538",
    "data-name": "Path 15538",
    d: "M35.973,0A35.973,35.973,0,1,0,71.945,35.973,35.973,35.973,0,0,0,35.973,0Zm0,68.675a32.7,32.7,0,1,1,32.7-32.7A32.7,32.7,0,0,1,35.973,68.675Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.59faacfdb1942b1c964ecbbd9c20b02a.svg";
export { ForwardRef as ReactComponent };